export const TrackApiPath = {
  UNIFIED_TRACK: '/api/track', // POST Unified Track
  BEACON_TRACK: '/api/track/beacon' // POST Beacon Track
}

export type TrackApiPath = (typeof TrackApiPath)[keyof typeof TrackApiPath]

export interface UnifiedTrackVars {
  command: string
  distribution_code: string
  visitor_id?: string | null
  session_id?: string | null
  item_id?: string | null
  category_id?: string | null
  brand_id?: string | null
  items?: TrackItem[] | null
  order_id?: string | null
  total_price?: number | null
  customer_id?: string | null
  rec_log_id?: number | null
  page_url?: string | null
  referrer?: string | null
  device_type?: string | null
  browser?: string | null
  dwell_time_ms?: number | null
  view_id?: string | null
  feature_page_id?: string | null
  feature_category_id?: string | null
}

export interface BeaconTrackVars {}

export interface TrackItem {
  item_id: string
  price?: number | null
  quantity?: number | null
  item_variation_id?: string | null
}

// 閲覧系（view / cart / dwell）は AWS 側で受けるため、この EP が返すのは
// identify / purchase / rec_click の結果のみ。event_id は view が返していた値で、
// Render 側の view 分岐を削除したため無くなった。
export interface UnifiedTrackResponse {
  status: string
  command: string
}

export type BeaconTrackResponse = UnifiedTrackResponse
